import Vue from 'vue';

export function isNullString(str) {
  if (str === '') return true;
  const regu = '^[ ]+$';
  const re = new RegExp(regu);
  return re.test(str);
}
export function isNullForDisplay(str, defValue) {
  if (str !== null && str !== undefined && str !== 'undefined') {
    if (typeof str === 'string' && (str.toUpperCase()) === 'NULL') {
      return defValue || '';
    }
    return `${str}`;
  }
  return defValue || '';
}

export function isNullForTransferValue(str) {
  if (str !== null && str !== undefined && !isNullString(str)) {
    if (typeof str === 'string' && (str.toUpperCase()) === 'NULL') {
      return false;
    }
    return true;
  }
  return false;
}

// 获取对象数组中指定key的值
export function getValuesByKeyFromArrayObject(arr, key) {
  const values = [];
  if (arr.length) {
    for (let i = 0; i < arr.length; i++) {
      values.push(arr[i][key]);
    }
  }
  return values;
}

const isClass = (o) => Object.prototype.toString.call(o).slice(8, -1);

const deepClone = function deepClone(obj) {
  let result;
  const oClass = isClass(obj);
  if (oClass === 'Object') {
    result = {};
  } else if (oClass === 'Array') {
    result = [];
  } else {
    return obj;
  }
  if (oClass === 'Object') {
    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const key in obj) {
      result[key] = deepClone(obj[key]);
    }
  } else if (oClass === 'Array') {
    for (let i = 0; i < obj.length; i++) {
      result.push(deepClone(obj[i]));
    }
  }
  return result;
};
/**
 * 克隆一个类
 * @param originalObj
 * @param obj
 * @returns {any}
 */
export const shallowClones = (obj, originalObj) => {
  const newObj = obj ? deepClone(obj) : deepClone(originalObj);
  if (originalObj) {
    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const key in originalObj) {
      newObj[key] = originalObj[key];
    }
  }
  return newObj;
};

// 判断2个类的参数和值是否一样
export const comparisonObject = (obj1, obj2) => {
  if (!obj1 || !obj2) {
    return false;
  }
  return (JSON.stringify(obj1) === JSON.stringify(obj2));
};

// 存储 localStorage
export const setLocalStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (err) {
    console.error('setLocalStorage Error：', key);
  }
};

// 获取 localStorage
export const getLocalStorage = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (err) {
    console.error('getLocalStorage Error：', key);
  }
  return null;
};

// 移除 localStorage
export const removeLocalStorage = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch (err) {
    console.error('removeLocalStorage Error：', key);
  }
};

// 将数组转成 object
export const arr2obj = (arr = [], { key = 'value' }) => {
  if (!arr || arr.length <= 0) {
    return {};
  }

  return arr.reduce((obj, cur) => ({ ...obj, [cur[key]]: cur }), {});
};

export const getFileNameFromUrl = (url) => {
  if (!url) {
    return '';
  }
  try {
    return url.substring(url.lastIndexOf('/') + 1, url.length);
  } catch (err) {
    //
  }
  return url;
};

export const isImage = (url) => {
  try {
    const fileName = getFileNameFromUrl(url);
    const fileNameArr = fileName.split('.');
    const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
    if (['jpg', 'png', 'gif', 'bmp', 'jpeg'].indexOf(ext) > -1) {
      return true;
    }
  } catch (err) {

  }
  return false;
};

// 校验字符长度  1个中文=2个字符 (包含 len)
export const checkCharLength = (str, len) => {
  if (!len) {
    return true;
  }
  let charLen = 0;
  const strLen = `${str}`.length;
  for (let i = 0; i < strLen; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
      charLen += 2;
    } else {
      charLen += 1;
    }
  }
  return charLen <= len;
};

export const RGBToHex = (rgbColor) => {
  const regex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
  const match = regex.exec(rgbColor);
  if (match && match.length === 4) {
    const r = match[1];
    const g = match[2];
    const b = match[3];
    const hex = `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
    return hex;
  }
  return '';
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    let result = '';
    reader.readAsDataURL(file);
    reader.onload = () => {
      result = reader.result;
    };
    reader.onloadend = () => {
      resolve(result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

export const subCharByLength = (str, len, suffix = '...') => {
  if (!len) {
    return str;
  }
  let subChar = '';
  let charLen = 0;
  const strLen = `${str}`.length;
  // if (len >= strLen) {
  //   return str;
  // }
  let i;
  for (i = 0; i < strLen; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
      charLen += 2;
    } else {
      charLen += 1;
    }
    if (charLen > len) {
      break;
    }
    subChar += str.charAt(i);
  }
  return `${subChar}${strLen > i ? suffix : ''}`;
};

export const formatCardNumber = (cardNumber) => {
  if (!cardNumber) {
    return '--';
  }
  // 卡号位数未知 但是格式要是类似这种   1234 56** **** 3456
  // 所以需要先判断卡号位数
  const cardNumberLength = cardNumber.length;
  if (cardNumberLength <= 4) {
    return cardNumber;
  }
  if (cardNumberLength <= 8) {
    return cardNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
  }
  if (cardNumberLength <= 12) {
    return cardNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
  }
  if (cardNumberLength <= 16) {
    return cardNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
  }
  if (cardNumberLength <= 20) {
    return cardNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
  }
  if (cardNumberLength <= 24) {
    return cardNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
  }
  if (cardNumberLength <= 28) {
    return cardNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
  }
  if (cardNumberLength <= 32) {
    return cardNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
  }
};

// 将页面滚动至指定类名的Dom
export const scrollToDom = ({
  className,
  options = {
    block: 'center',
    behavior: 'smooth',
  },
  extraFn,
} = {}) => {
  Vue.prototype.$nextTick(() => {
    if (extraFn) extraFn();
    const errorDom = document.querySelector(`.${className}`);
    if (errorDom) {
      errorDom.scrollIntoView(options);
    }
  });
};

// 将页面滚动至默认校验错误的Dom
export const scrollToErrorDom = (args = {}) => {
  scrollToDom({ className: 'is-error', ...args });
};
